module.exports = __webpack_public_path__ + "static/media/2.b68c22bd.JPG";